/* eslint-disable ember/no-classic-components, warp-drive/no-legacy-request-patterns */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

@tagName('')
export default class EntityPublisher extends Component {
  iconSize = 24;
  displayWarning = false;
  @tracked
  dialogOpen = false;
  warningMessage = '';
  entity = null;

  // Functions
  afterToggle() {}

  @action
  decideAction() {
    if (this.displayWarning && this.entity.isPublished) {
      this.dialogOpen = true;
      return;
    }
    this.togglePublish(this.entity);
  }

  // Publish/unpublish entities
  @action
  togglePublish(entity) {
    entity.toggleProperty('isPublished');
    entity.save().then((entity) => {
      this.afterToggle(entity);

      if (this.displayWarning) {
        this.dialogOpen = false;
      }
    });
  }
}
